var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4",attrs:{"id":"MyTicket"}},[_c('p',[_vm._v("請妥善保管你的票券，僅提供給工作人員或攤位人員於活動使用")]),_vm._v(" "),_c('center',[_c('canvas',{attrs:{"id":"qrcode","height":"240","width":"240"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eebe212","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MyTicket.vue
// module id = 256
// module chunks = 1